module.exports = __webpack_public_path__ + "static/psa-0841bbf029336ca518af5e148915df80.jpg";